export default "__VITE_ASSET__IOQXYOSc__"